const Balance = require('../../constants/Balance');
const BattleCalc = require('../BattleCalc');
const DeathEvent = require('./DeathEvent');
const { logError } = require('../logger');

const DamageEvent = function (battleState, instigator, dmg, cause) {
  try {
    this.eventHandle = 'damage';
    this.cause = cause;

    this.damage = dmg - 2 + Math.random() * 5;

    // check for crit
    let crit_chance = 0.1;
    // from weapon
    if (instigator && instigator.equipment) {
      if (instigator.equipment.weapon?.suffix === 'destruction') {
        crit_chance += 0.2;
      }
    }
    // TODO - crit chance from stats?
    if (Math.random() <= crit_chance) {
      this.crit = true;
      this.damage *= Balance.CRITICAL_STRIKE_MOD;
    }

    // apply equipment damage mods
    let equipment_damage_mod = 1.0;
    for (const item of Object.values(instigator?.equipment ?? {})) {
      if (cause.physical) {
        if (item?.physDamageMod) {
          equipment_damage_mod += item.physDamageMod;
        }
      }

      if (cause.magic) {
        if (item?.magicDamageMod) {
          equipment_damage_mod += item.magicDamageMod;
        }
        if (item?.type === 'staff' && item?.damageMod) {
          equipment_damage_mod += item.damageMod;
        }
      }

      if (cause.melee) {
        if (item?.meleeDamageMod) {
          equipment_damage_mod += item.meleeDamageMod;
        }
        if (item?.slot === 'weapon' && item?.damageMod) {
          equipment_damage_mod += item.damageMod;
        }
      }

      if (cause.bow) {
        if (item?.bowDamageMod) {
          equipment_damage_mod += item.bowDamageMod;
        }
        if (item?.type === 'bow' && item?.damageMod) {
          equipment_damage_mod += item.damageMod;
        }
      }
    }
    this.damage *= equipment_damage_mod;

    this.applyStanceAdjustments = (victim) => {
      try {
        this.damage *= BattleCalc.getDamageModFromStances({
          instigator,
          victim,
        });
      } catch (err) {
        logError(err, {
          module: 'DamageEvent',
          func: 'applyStanceAdjustments',
          instigator: JSON.stringify(instigator),
          victim: JSON.stringify(victim),
        });
      }
      return this.damage;
    };

    this.applyArmorAdjustment = (victim) => {
      try {
        if (!victim || !victim.attributes) {
          return this.damage;
        }

        let armorTotal = victim.attributes.armorClass;
        const {
          equipment: { weapon, off_hand },
        } = instigator;

        if (cause.handle === 'lightning') {
          armorTotal = 0;
        } else if (
          (cause.weapon && weapon?.suffix === 'penetration') ||
          (cause.bow &&
            off_hand?.type === 'bow' &&
            off_hand.suffix === 'penetration')
        ) {
          armorTotal *= 0.5;
        }

        this.damage *= 1 - Balance.getDmgReduxFromArmorClass(armorTotal);

        return this.damage;
      } catch (err) {
        logError(err, {
          module: 'DamageEvent',
          func: 'applyArmorAdjustment',
          instigator,
          victim,
          dmg,
          cause,
        });
      }
    };

    this.execute = (victim, apply_affinities = true, is_dummy = false) => {
      try {
        if (!instigator || !victim) return;

        this.victimId = victim.uid;

        // apply hero Affinity logic
        if (apply_affinities) {
          this.damage *= BattleCalc.getDamageModFromAffinities(
            instigator,
            victim
          );
        }

        // finalize damage as an integer
        this.damage =
          // poppets deal no damage, but options on poppets do
          instigator.handle === 'poppet' &&
          cause.eventHandle !== 'option_attack'
            ? 0
            : Math.max(0, Math.floor(this.damage));
        if (isNaN(this.damage)) {
          return;
        }

        victim.hp -= Math.min(this.damage, victim.hp);

        if (is_dummy) return;

        this.affectedPieces = [victim];
        battleState.onBattleEvent(this);

        if (isNaN(victim.hp) || victim.hp <= 0) {
          // timeout so the ability & damage event finish processing first
          setTimeout(() => {
            try {
              const death = new DeathEvent(battleState);
              death.execute(victim);
            } catch (err) {
              logError(err);
            }
          }, 1);
        }
      } catch (err) {
        logError(err, {
          module: 'DamageEvent',
          func: 'execute',
          instigator: JSON.stringify(instigator),
          victim: JSON.stringify(victim),
          dmg,
        });
      }
    };
  } catch (err) {
    logError(err, {
      module: 'DamageEvent',
      func: 'constructor',
      battleState,
      instigator: JSON.stringify(instigator),
      dmg,
    });
  }
};
module.exports = DamageEvent;
